import type {Pinia} from 'pinia';
import {defineNuxtPlugin, useAuth} from '#imports';

/**
 * Exposes a minimal `$session` contract on NuxtApp so other modules
 * (e.g. i18n) can read login state without depending on auth or Pinia.
 */
export default defineNuxtPlugin({
    name: 'session',
    setup(nuxtApp) {
        const auth = useAuth(nuxtApp.$pinia as Pinia);
        return {
            provide: {
                session: {
                    get loggedIn() {
                        return auth.loggedIn;
                    },
                },
            },
        };
    },
});
